import { TEmployeeFormData } from 'src/@types';
import { IEmployeeSFilter } from 'src/@types/SearchFilterTypes';
import { IEmployee } from 'src/models';
import objectToQueryString from 'src/utils/objectToQueryString';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/v1/oprtr';

/**
 * 직원 목록 조회
 */
export const getEmployees = async (searchFilter?: IEmployeeSFilter) => {
  try {
    const url = '/oprtr' + objectToQueryString(searchFilter || {});
    const response = await instance.get<TApiResponseData<IEmployee[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 직원 정보 단건조회
 * @param oprtrSid 사용자 고유번호
 */
export const getDetail = async (oprtrSid: number) => {
  const url = `/oprtr/${oprtrSid}`;
  const response = await instance.get<TApiResponseData<IEmployee>>(url);

  // 성공 시 데이터 반환
  if (response.data.resultCode === 'S' && response.data.data) {
    return {
      data: response.data.data,
    };
  }
};

/**
 * loginId 중복 체크
 * @param loginId 중복 체크할 loginId
 * @returns boolean | undefined
 */
export const checkLoginIdDuplicate = async (loginId: string) => {
  const url = `${SUB_URL}/loginId/check?loginId=${loginId}`;
  const response = await instance.get<TApiResponseData<boolean>>(url);

  if (response.data.resultCode === 'S') {
    return response.data.data;
  }
};

/**
 * 직원 정보 등록
 * @param empInfo 직원 등록 정보: TEmployeeFormData
 */
export const createEmployee = async (empInfo: TEmployeeFormData) => {
  try {
    const url = `${SUB_URL}`;
    const payload = empInfo;
    const response = await instance.post<TApiResponseData<IEmployee>>(url, payload);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    throw new Error(
      response.data.resultCode === 'F' && response.data.errorMessage
        ? response.data.errorMessage
        : '직원 정보 등록에 실패했습니다.',
    );
  } catch (error) {
    console.error(error);
    return {
      success: false,
      errorMessage: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};

/**
 * 직원 정보 수정
 * @param oprtrSid 사용자 고유번호
 * @param empInfo 직원 등록 정보: TEmployeeFormData
 */
export const updateEmployee = async (data: TEmployeeFormData) => {
  try {
    const url = `${SUB_URL}/${data.oprtrSid}`;
    const payload = data;
    const response = await instance.put<TApiResponseData<IEmployee>>(url, payload);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    throw new Error(
      response.data.resultCode === 'F' && response.data.errorMessage
        ? response.data.errorMessage
        : '직원 정보 수정에 실패했습니다.',
    );
  } catch (error) {
    console.error(error);
    return {
      success: false,
      errorMessage: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};

/**
 * 직원 정보 삭제
 * @param oprtrSid 직원 고유번호
 */
export const deleteEmployee = async (oprtrSid: number) => {
  try {
    const url = `/oprtr/${oprtrSid}`;
    const response = await instance.delete<TApiResponseData<IEmployee>>(url);

    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    throw new Error(
      response.data.resultCode === 'F' && response.data.errorMessage
        ? response.data.errorMessage
        : '직원정보 삭제에 실패했습니다.',
    );
  } catch (error) {
    console.error(error);
    return {
      success: false,
      errorMessage: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};
